import React, { useState } from 'react'
import Sidebar from '../../Include/Sidebar'
import Header from '../../Include/Header'

const MaterialCutStock = () => {

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleOpenSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
                <Header handleOpen={handleOpenSidebar} />
                <Sidebar />

            </div>
        </>
    )
}

export default MaterialCutStock